import Axios from 'axios';

const FormSubmissionMixin = {
    data() {
        return {
            processing: false,
            success: false,
            error: false,
            errorMessage: '',
            form: {},
            postUrl: ''
        };
    },

    methods: {
        validateAndSubmit() {
            if (this.processing) {
                return;
            }
            this.error = false;
            this.processing = true;
            this.success = false;

            this.$validator
                .validateAll()
                .then(result => {
                    if (!result) {
                        this.processing = false;
                        return false;
                    }

                    this.validateReCaptcha();
                    return true;
                })
                .catch(() => {
                    this.processing = false;
                    return false;
                });
        },

        validateReCaptcha() {
            this.$recaptcha('contact').then(token => {
                this.form.token = token;
                this.submitForm(this.postUrl, this.form);
            });
        },

        submitForm(url, data) {
            Axios({
                method: 'post',
                url: url + '?nodeId=' + this.$root.settings.nodeId,
                data
            })
                .then(response => {
                    if (!response.data.success) {
                        this.error = true;
                        this.errorMessage = response.data.message;
                        this.success = false;
                        this.processing = false;
                        return false;
                    }

                    this.error = false;
                    this.success = true;
                    this.processing = false;
                    return true;
                })
                .catch(() => {
                    this.error = true;
                    this.errorMessage =
                        'Er ging iets mis, probeer het later opnieuw.';
                    this.success = false;
                    this.processing = false;
                    return false;
                });
        }
    }
};

export default FormSubmissionMixin;
